import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { TAccount } from '@helpers/Accounts/accounts.types';
import { getDurationInMonths } from '@helpers/GetDurationInMonths/getDurationInMonths';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TCreditBuilderSteps = 1 | 2 | 3;

export const useGetCreditBuilderData = (
    accountId: NonNullable<TAccount['account_id']>
) => {
    const stateKey = useStateKey();
    const { data: account } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        suspense: true,
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            )
    });

    if (!account) {
        throw new Error();
    }
    return {
        activeStep: getCreditBuilderStage(account)
    };
};

const getCreditBuilderStage = (account: TAccount): TCreditBuilderSteps => {
    const loanDuration = getDurationInMonths(account.duration!);
    if (loanDuration === 3) return 1;
    if (loanDuration === 6) return 2;
    else return 3;
};
